











import { Component, Vue } from "vue-property-decorator";

@Component
export default class FileAlertModal extends Vue {
    message = "";

    open(msg: string) {
        this.message = msg;
        (this.$refs.alertModal as any).show();
    }

    hide() {
        this.message = "";
        (this.$refs.alertModal as any).hide();
    }
}
